define("media/components/media/label-media-item", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class="o--dropBody__item cLB--dropBody__item eLB--dropBody__item" id={{this.htmlId}}>
    <div class="cLB--label {{if this.isActive 'is--active'}}" {{on "click" (fn @updateLabel @label)}}>
      <span class={{unless this.isActive "u--hide"}}>
        {{svg-jar "check" class="o--icon o--icon--success"}}
      </span>
      <span class="u--ellipsis">
        <span>
          {{@label.trimmedTagName}}
        </span>
      </span>
      {{#unless @label.isSystemLabel}}
        <span
          class="cLB--label__icon--edit cLB--label__icon {{if this.isEditing 'is--active'}}"
          {{on "click" this.editingToggle}}
        >
          {{svg-jar "ellipsis-h" class="o--icon o--icon--light"}}
        </span>
      {{/unless}}
    </div>
    {{#if this.isEditing}}
      <div class="cLB--label__expand" {{on "click" (perform this.deleteLabel)}}>
        {{svg-jar "trash" class="o--icon--sm u--m__r__xs"}}
        <span>
          {{t "shared_words.delete"}}
        </span>
      </div>
    {{/if}}
  </li>
  */
  {
    "id": "7u8pkpcM",
    "block": "[[[10,\"li\"],[14,0,\"o--dropBody__item cLB--dropBody__item eLB--dropBody__item\"],[15,1,[30,0,[\"htmlId\"]]],[12],[1,\"\\n  \"],[11,0],[16,0,[29,[\"cLB--label \",[52,[30,0,[\"isActive\"]],\"is--active\"]]]],[4,[38,1],[\"click\",[28,[37,2],[[30,1],[30,2]],null]],null],[12],[1,\"\\n    \"],[10,1],[15,0,[52,[51,[30,0,[\"isActive\"]]],\"u--hide\"]],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[30,2,[\"trimmedTagName\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[51,[30,2,[\"isSystemLabel\"]]],[[[1,\"      \"],[11,1],[16,0,[29,[\"cLB--label__icon--edit cLB--label__icon \",[52,[30,0,[\"isEditing\"]],\"is--active\"]]]],[4,[38,1],[\"click\",[30,0,[\"editingToggle\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"ellipsis-h\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[41,[30,0,[\"isEditing\"]],[[[1,\"    \"],[11,0],[24,0,\"cLB--label__expand\"],[4,[38,1],[\"click\",[28,[37,5],[[30,0,[\"deleteLabel\"]]],null]],null],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"trash\"],[[\"class\"],[\"o--icon--sm u--m__r__xs\"]]]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,6],[\"shared_words.delete\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@updateLabel\",\"@label\"],false,[\"if\",\"on\",\"fn\",\"unless\",\"svg-jar\",\"perform\",\"t\"]]",
    "moduleName": "media/components/media/label-media-item.hbs",
    "isStrictMode": false
  });
  let LabelMediaItemComponent = _exports.default = (_class = class LabelMediaItemComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "dialogManager", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "isEditing", _descriptor3, this);
      _defineProperty(this, "htmlId", (0, _uuid.default)());
      _defineProperty(this, "deleteLabel", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_library.labels.manage.delete_header'), {
            description: this.intl.t('media_library.labels.manage.delete_message', {
              label_name: this.args.label.tagName
            }),
            confirmButton: this.intl.t('shared_words.delete')
          });
          if (!didConfirm) {
            return;
          }
          this.args.deleteLabel.perform(this.args.label);
        }
      }), null, "deleteLabel", null));
      this.isEditing = false;
    }
    get isActive() {
      return (0, _utils.isPresent)(this.args.mediaLabels) && !this.args.mediaLabels.any(label => label.isDestroyed) ? this.args.mediaLabels?.includes(this.args.label) : false;
    }
    editingToggle(event) {
      event.stopPropagation();
      this.isEditing = !this.isEditing;
      if (this.isEditing) {
        // This is all logic to make sure label and its 'editing' drop-down is fully visible --G
        const labelListElement = document.querySelector('.eLB--dropBody');
        if (labelListElement === null) return;
        const labelListOffsetTop = labelListElement.getBoundingClientRect().top;
        const element = document.getElementById(this.htmlId);
        if (element === null) return;
        const targetOffsetTop = element.getBoundingClientRect().top;
        const doubleTargetHeight = element.clientHeight * 2;
        const addLabelElement = document.querySelector('.eLB--dropFooter');
        if (addLabelElement === null) return;
        const addLabelOffsetTop = addLabelElement.getBoundingClientRect().top;
        const offsetBottomDifference = addLabelOffsetTop - targetOffsetTop;
        let differenceToMove;
        if (targetOffsetTop < labelListOffsetTop) {
          // If item on top, label not fully visible
          differenceToMove = labelListOffsetTop - targetOffsetTop;
          labelListElement.scrollBy({
            top: differenceToMove,
            left: 0,
            behavior: 'smooth'
          });
        } else if (offsetBottomDifference < doubleTargetHeight) {
          // If item on bottom, not fully visible
          differenceToMove = doubleTargetHeight - offsetBottomDifference;
          labelListElement.scrollBy({
            top: differenceToMove,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "editingToggle", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editingToggle"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LabelMediaItemComponent);
});